module.exports = __webpack_public_path__ + "static/img/P3.4c4d992.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medusa/P3.png
// module id = KXUn
// module chunks = 0